const BLANK_VALUES = Object.freeze({
  // Dropdowns have a default value of undefined to have no option selected.
  dropdown: undefined,
  // Text inputs have a default value of an empty string to be blank.
  text: '',
  // Checkboxes have a default value of false to be unchecked.
  checkbox: false,
});

export const FIELD_BLANK_VALUES = Object.freeze({
  // Readiness.
  hasApiOwnership: BLANK_VALUES.dropdown,
  apiEndpointsUsed: BLANK_VALUES.text,
  ownsAllEndpoints: BLANK_VALUES.dropdown,
  hasPermissionForEndpoints: BLANK_VALUES.text,
  usesProductionEndpoints: BLANK_VALUES.dropdown,
  paidApi: BLANK_VALUES.dropdown,
  // Test account.
  testAccountUsername: BLANK_VALUES.text,
  testAccountPassword: BLANK_VALUES.text,
  testAccountOnlySupportsSso: BLANK_VALUES.checkbox,
  ssoTestAccountCreated: BLANK_VALUES.checkbox,
  testAccountNotes: BLANK_VALUES.text,
  // App details.
  hasBeenLaunched: BLANK_VALUES.dropdown,
  isReplacementIntegration: BLANK_VALUES.dropdown,
  alreadyManagingSimilarIntegration: BLANK_VALUES.dropdown,
  linkToOtherIntegrations: BLANK_VALUES.text,
  newIntegrationRationale: BLANK_VALUES.text,
  homepageUrl: BLANK_VALUES.text,
  apiDocsUrl: BLANK_VALUES.text,
  apiDocumentationNotes: BLANK_VALUES.text,
  primaryColor: BLANK_VALUES.text,
  twitterUsername: BLANK_VALUES.text,
  // Contact details.
  marketingContactEmail: BLANK_VALUES.text,
  securityContactEmail: BLANK_VALUES.text,
  technicalContactEmail: BLANK_VALUES.text,
  expectedResponseTime: BLANK_VALUES.text,
  // Compliance.
  companyBaseCountry: BLANK_VALUES.text,
  transmitsSensitiveValues: BLANK_VALUES.dropdown,
  collectsFinancialInfo: BLANK_VALUES.dropdown,
  usesThirdPartyApis: BLANK_VALUES.dropdown,
  permissionForThirdPartyApis: BLANK_VALUES.text,
  usesZapierBranding: BLANK_VALUES.dropdown,
  usesCurrentZapierBranding: BLANK_VALUES.checkbox,
});
